module.exports = __webpack_public_path__ + "img/YesOrNo.ea7a29ea.svg";